import React from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from '../../utils/helpers';

const Card = ({ title, startingPrice, hideStartingAtLabel, children }) => {
  return (
    <div className="card">
      <div className="card__header">
        <h5 className="card__title">{title}</h5>
        <div className="card__price">
          <div className="card__price-amount">
            {formatPrice(startingPrice)}
          </div>

          {!hideStartingAtLabel && (
            <div className="card__price-label">Starting at</div>
          )}
        </div>
      </div>

      <div className="card__body">{children}</div>
    </div>
  );
};

Card.propTypes = {
  title: PropTypes.string.isRequired,
  startingPrice: PropTypes.number.isRequired,
  hideStartingAtLabel: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Card;
